import { Button } from '@arionbanki/arionui';
import { classNames as cx, getMode } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { type MouseEventHandler, useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';

const STICKY_FOOTER_CLASSNAME = 'sticky-footer-container';

type FooterProps = Readonly<{
	className?: string;
	handleNext?: MouseEventHandler;
	handlePrev?: MouseEventHandler;
	isDisabled?: boolean;
	mode?: 'stroked' | 'blue' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';
	next?: string;
	prev?: string;
}>;

export function Footer(props: FooterProps) {
	return (
		<>
			<FooterInner {...props} />
			<StickyFooter {...props} />
		</>
	);
}

function FooterInner(props: FooterProps) {
	const { className, handleNext, handlePrev, isDisabled, next, prev } = props;

	const prevButton = prev && handlePrev && (
		<Button mode="stroked" onClick={handlePrev} size="large">
			{prev}
		</Button>
	);

	const nextButton = next && handleNext && (
		<Button disabled={isDisabled} mode={props.mode} onClick={handleNext} size="large">
			{next}
		</Button>
	);

	const prevCN = cx({ 'col-6': prevButton, 'd-none': !prevButton });
	const nextCN = cx('text-end', { 'col-6': prevButton, 'col-12': !prevButton });

	return (
		<footer className={cx('footer py-4 mt-5', className)}>
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="row">
							{prevButton && <div className={prevCN}>{prevButton}</div>}
							{nextButton && <div className={nextCN}>{nextButton}</div>}
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

function StickyFooter(props: FooterProps) {
	const { flowType } = useContext(AppContext);
	const className = cx(`sticky-footer theme--${getMode(flowType)}`, props.className);

	useEffect(() => {
		document.body.classList.add(STICKY_FOOTER_CLASSNAME);
		return () => {
			document.body.classList.remove(STICKY_FOOTER_CLASSNAME);
		};
	}, []);

	return ReactDOM.createPortal(<FooterInner {...props} className={className} />, document.body);
}
